export const OFFLINE_DATA = "OFFLINE_DATA";
export const THREAD_MSG = "THREAD_MSG";
export const CLEAR = "CLEAR";
